module.exports = __webpack_public_path__ + "static/media/visas1.c7315629.PNG";